module.exports = __webpack_public_path__ + "img/15passenger_parked.460e5159.svg";